import { Component, OnInit, inject } from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-recommended-products-tab',
  templateUrl: './recommended-products-tab.component.html',
  styleUrl: './recommended-products-tab.component.scss',
  standalone: false,
})
export class RecommendedProductsTabComponent implements OnInit {
  private ss = inject(SessionStorageService);

  solutions = [{ label: 'All', value: 'ALL' }];
  selectedSolution = 'ALL';
  selectedUnit = null;
  start = DateTime.now().minus({ months: 6 }).toUTC().toISO();
  end = DateTime.now().toUTC().toISO();
  rights = this.ss.get('rights');
  filteredUnits;

  ngOnInit(): void {
    const globals = this.ss.get('globals');
    this.selectedUnit = globals?.user.managerUnits[0].id;
  }

  changeSolution(ev) {
    this.selectedSolution = ev.value;
  }

  changeDate(ev) {
    const { position, value } = ev;
    this[position] = value;
  }

  changeUnit(ev) {
    this.selectedUnit = ev;
  }
}
